import { Card, Flex, Typography } from "antd";
import Chart from "react-apexcharts";
import React from "react";

export default function DefaultRate() {
  const defaultRateOptions = {
    chart: {
      type: "bar",
      height: 229,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "6%",
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: ["$0-$100", "$100-$250", "$250-$500", "$500-$1K", "$1K-$1.5K", "$1.5K-$2K", "$2K-$2.5K", "$2.5K-$3K"],
      labels: {
        style: {
          fontSize: "12px",
          fontFamily: "Helvetica, Arial, sans-serif",
          colors: "#979797",
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: {
        formatter: function (val) {
          return val + "%";
        },
        style: {
          fontSize: "12px",
          colors: "#979797",
        },
      },
    },
    colors: ["#722ed1"],
    tooltip: {
      y: {
        formatter: function (val) {
          return val + "%";
        },
      },
    },
    grid: {
      show: false,
      //   borderColor: "#f0f0f0",
      //   strokeDashArray: 0,
      //   xaxis: {
      //     lines: {
      //       show: false,
      //     },
      //   },
      //   yaxis: {
      //     lines: {
      //       show: true,
      //     },
      //   },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },
  };

  const defaultRateSeries = [
    {
      name: "Default Rate",
      data: [60, 90, 20, 70, 50, 100, 80, 70],
    },
  ];

  return (
    <Card style={{ width: "100%" }}>
      <Flex vertical gap={30}>
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          Default Rate
        </Typography.Title>
        <Chart options={defaultRateOptions} series={defaultRateSeries} type="bar" height={228} />
      </Flex>
    </Card>
  );
}
